import React from 'react';
import { BadgeCheckIcon, CheckIcon, HeadsetIcon } from 'lucide-react';
import { MapPlaceholder } from './MapPlaceholder';
import type { FormVariant } from '../../types/form';
export function SupportPanel({
  variant
}: {
  variant: FormVariant;
}) {
  const office = variant.contactCards?.find(c => c.label === 'Office');
  return <div className="max-w-[520px]" data-id="element-536" data-mp="2moirzf8ykcl9">
      <p className="text-[17px] leading-[1.5] text-ink-muted lg:hidden" data-id="element-537" data-mp="2mlednp1s40gv">{variant.subheadline}</p>

      {variant.points && <ul className="mt-6 space-y-3.5 lg:mt-0" data-id="element-538" data-mp="3fbd8k12nmrtg">
          {variant.points.map(point => <li key={point} className="flex items-start gap-3 text-[16px] leading-[1.5] text-ink-soft" data-id="element-539" data-mp="3acach64njvxm">
              <span className="mt-[3px] flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-soft" data-id="element-540" data-mp="35e8j9sdiig8f">
                <CheckIcon className="h-3 w-3 text-brand" strokeWidth={2.75} aria-hidden="true" data-id="element-541" data-mp="1yyogb10dku2l" />
              </span>
              {point}
            </li>)}
        </ul>}

      {variant.contactCards && <ul className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:mt-0" data-id="element-542" data-mp="7k8lipp3sobz">
          {variant.contactCards.map(card => {
        const Icon = card.icon;
        const content = <>
                <Icon className="h-[18px] w-[18px] text-brand" strokeWidth={1.9} aria-hidden="true" data-id="element-543" data-mp="3tsrp7cap9arq" />
                <span className="mt-3 block text-[13px] text-ink-muted" data-id="element-544" data-mp="2mgs1r8t8u5o">{card.label}</span>
                <span className="mt-0.5 block text-[15px] font-semibold text-ink" data-id="element-545" data-mp="3jyrdgrkwx7a1">{card.value}</span>
              </>;
        return <li key={card.label} data-id="element-546" data-mp="3b0yy5nf6xzmn">
                {card.href ? <a href={card.href} className="block h-full rounded-[12px] border border-canvas-line bg-white p-4 transition-colors duration-150 ease-out hover:border-ink/25" data-id="element-547" data-mp="3fza7lx1kq84c">
                    {content}
                  </a> : <div className="h-full rounded-[12px] border border-canvas-line bg-white p-4" data-id="element-548" data-mp="2mw7sluc519z9">{content}</div>}
              </li>;
      })}
        </ul>}

      {variant.showMap && office && <div className="mt-4" data-id="element-549" data-mp="2d7prfbzy50v3">
          <MapPlaceholder address={office.value} data-id="element-550" data-mp="2d4k4a2avo920" />
        </div>}

      {variant.testimonial && <figure className="mt-8 border-t border-canvas-line pt-6" data-id="element-551" data-mp="285h16negkcwo">
          <blockquote className="text-[15px] leading-[1.6] text-ink" data-id="element-552" data-mp="35u0wayul5nxp">“{variant.testimonial.quote}”</blockquote>
          <figcaption className="mt-4 flex items-center gap-3" data-id="element-553" data-mp="30wscyuxpbduv">
            <img src={variant.testimonial.image} alt="" className="h-10 w-10 rounded-full object-cover" data-id="element-554" data-mp="2vwcwvvm1bs97" />
            <span data-id="element-555" data-mp="2r0fezkv4idub">
              <span className="block text-[14px] font-semibold text-ink" data-id="element-556" data-mp="1khr35itkt7rh">{variant.testimonial.name}</span>
              <span className="block text-[13px] text-ink-muted" data-id="element-557" data-mp="1fied6p7erkko">{variant.testimonial.business}</span>
            </span>
          </figcaption>
        </figure>}

      <ul className={`flex flex-wrap gap-2 ${variant.testimonial ? 'mt-6' : 'mt-8 border-t border-canvas-line pt-6'}`} data-id="element-558" data-mp="3r4eut08u2wiu">
        <li className="inline-flex items-center gap-2 rounded-full border border-canvas-line bg-white px-3 py-1.5 text-[13px] font-medium text-ink" data-id="element-559" data-mp="4zb9bpc7jz8q">
          <BadgeCheckIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-560" data-mp="9rcfctis8tqb" />
          RRA EBM certified
        </li>
        <li className="inline-flex items-center gap-2 rounded-full border border-canvas-line bg-white px-3 py-1.5 text-[13px] font-medium text-ink" data-id="element-561" data-mp="eqxhfct91i79">
          <HeadsetIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-562" data-mp="np9he5g09scd" />
          Local support in Kigali
        </li>
      </ul>

      {variant.image && <img src={variant.image.src} alt={variant.image.alt} loading="lazy" className="mt-8 hidden h-[220px] w-full rounded-[12px] object-cover lg:block" data-id="element-563" data-mp="sm9l49pduj0b" />}
    </div>;
}